import { defineComponent as _defineComponent } from 'vue'
import GeneralUserView from "@/components/master/user/general/GeneralUserView.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'GenaralUserMaster',
  setup(__props) {


return { __sfc: true,GeneralUserView }
}

})